import CustomComponent from '../CustomComponent';

export const FAVORITE_CLICK_EVENT = 'toggle-favorite';

export class FavoriteIconComponent extends CustomComponent {
	static key = 'lta-favorite-icon';

	static get observedAttributes() {
		return ['is-favorite', 'width', 'height', 'classes'];
	}

	isFavorite() {
		return this.getAttribute('is-favorite')?.toLowerCase() === 'true';
	}

	render() {
		const { width = '1em', height = '1em', classes = '' } = this.props;
		const isFavorite = this.isFavorite();
		const iconName = isFavorite ? 'favorite-fill' : 'favorite';

		return `
			<span class="js-fav-venue u-cursor-pointer ${classes}">
				<svg
				class="lta-icon"
				width=${width}
				height=${height}
				alt="${isFavorite ? 'favorite-fill' : 'favorite'}"
				aria-hidden="true"
				>
				<use xlink:href="/static/images/icons/lta-icons.svg#${iconName}" />
				</svg>
			</span>
		`;
	}

	afterRender() {
		this.querySelector('.js-fav-venue')?.addEventListener('click', this.handleToggle.bind(this));
	}

	onUnload() {
		this.querySelector('.js-fav-venue')?.removeEventListener('click', this.handleToggle.bind(this));
	}

	async handleToggle(event) {
		const isFavorite = this.isFavorite();
		event.preventDefault();
		event.stopPropagation();
		this.dispatchEvent(
			new CustomEvent(FAVORITE_CLICK_EVENT, {
				bubbles: true,
				composed: true,
				detail: {
					isFavorite: !isFavorite
				}
			})
		);
	}
}

export default FavoriteIconComponent;
